import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import {API_DOMAIN_AMP, API_ENDPOINT_AMP_STORIES, API_SECTION_DEALS} from '../../Constants';

const useStyles = makeStyles(theme => ({
  modalView: {
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '90vw',
    height: '90vh',
    [theme.breakpoints.down('sm')]: {
      width: '100vw',
      height: '80vh'
    }
  }
}))

export default ({cardIdsQueryString = null, onClose = () => {}}) => {
  const classes = useStyles();
  // let cardIdsQueryString = '';
  // cardIds.forEach((item, index) => {
  //   cardIdsQueryString += `${item}`;
  //   if(index < cardIds.length - 1) cardIdsQueryString += `,`;
  // })
  console.log('cardsIds cardIdsQueryString ', cardIdsQueryString);
    // https://www.telegraph.co.uk/visual-stories/best-islands-to-visit/
    // <div>

    return (<Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={true}
      onClose={onClose}
    >
      <div className={classes.modalView}>
        {
          cardIdsQueryString && (<iframe allowfullscreen="" style={{width: '100%', height: '100%', border: 'none'}} src={`${API_DOMAIN_AMP}${API_SECTION_DEALS}${API_ENDPOINT_AMP_STORIES}?card_ids=${cardIdsQueryString}`}></iframe>)
        }
      </div>
    </Modal>)

  //   return (<>
  // </>)
  // </div>
}
